import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApprovementState } from './approvement.types';
import { ApprovementRequest } from '../../models/approvementRequest';

const initialState: ApprovementState = {
  approvement: null,
  approvementId: null,
  loading: false,
  error: null,
};

const approvementSlice = createSlice({
  name: 'approvement',
  initialState,
  reducers: {
    setApprovementId: (state, action: PayloadAction<string | null>) => {
      state.approvementId = action.payload;
      state.loading = true;
    },
    approvementUpdated: (state, action: PayloadAction<ApprovementRequest>) => {
      state.approvement = action.payload;
      state.loading = false;
      state.error = null;
    },
    approvementListenerError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetApprovement: (state) => {
      state.approvement = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setApprovementId,
  approvementUpdated,
  approvementListenerError,
  resetApprovement,
} = approvementSlice.actions;

export default approvementSlice.reducer;
